import { MenuItem, MenuHeading } from '@kasasa/fbase-components/lib';

const menuItems: (MenuItem | MenuHeading)[] = [
  { icon: 'fa-list-alt', label: 'Job Queue', to: '/jobqueue' },
  { icon: 'fa-arrow-up', label: 'Upgrade Jobs', to: '/upgradejobs' },
  { icon: 'fa-sync', label: 'Reload History', to: '/reloadhistory' },
  { icon: 'fa-arrow-circle-up', label: 'KRP Processing Dashboard', to: '/processingdashboard' },
  { icon: 'fa-list-ul', label: 'Audit Log', to: '/auditlog' },
];

export default menuItems;
